const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'ico', 'tiff', 'tif'];
const PDF_EXTENSIONS = ['pdf'];

function getExtension(filename?: string): string {
  if (!filename) return '';
  return filename.split('.').pop()?.toLowerCase() || '';
}

/**
 * Détecte le type de fichier à partir du contentType ET du nom de fichier.
 * Combine les deux sources pour être robuste face aux contentType manquants,
 * non-standard (image/jpg au lieu de image/jpeg), ou incorrects.
 */
export function detectFileType(filename?: string, contentType?: string): { isImage: boolean; isPdf: boolean; fileIcon: string } {
  const ext = getExtension(filename);
  const ct = (contentType || '').toLowerCase();

  const isImage = ct.startsWith('image/') || IMAGE_EXTENSIONS.includes(ext);
  const isPdf = ct === 'application/pdf' || PDF_EXTENSIONS.includes(ext);

  const fileIcon = isImage ? '🖼️' : isPdf ? '📄' : '📎';

  return { isImage, isPdf, fileIcon };
}
